const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoSupervielle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.43,3.57c.79,2.09,1.7,6.32-.43,10.98-.02.06.05.11.13.06,2.55-1.7,4.77-4.96,5.5-7.62-2.53-1.32-4.06-2.69-4.98-3.56-.12-.12-.27.01-.22.14Z",
    style: {
      fill: "#ed1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9,9.05c-2.11-.34-4.16-1.04-5.5-1.69-.77,2.07-2.27,4.29-3.83,5.81-.09.07-.02.2.12.1,3.34-2.36,6.83-3.49,9.22-3.96.13-.03.13-.23,0-.26Z",
    style: {
      fill: "#840041"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoSupervielle);
export default __webpack_public_path__ + "static/media/banco-supervielle.1be83f3c30fab2c59cbc4b805bd9f61e.svg";
export { ForwardRef as ReactComponent };